__turbopack_context__.v({
  "iframe": "embedded-module-scss-module__4-RW0a__iframe",
  "ratio-16_9": "embedded-module-scss-module__4-RW0a__ratio-16_9",
  "ratio-1_1": "embedded-module-scss-module__4-RW0a__ratio-1_1",
  "ratio-3_4": "embedded-module-scss-module__4-RW0a__ratio-3_4",
  "skeleton": "embedded-module-scss-module__4-RW0a__skeleton",
  "wrapper": "embedded-module-scss-module__4-RW0a__wrapper",
});
